import axios from "axios";

const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

export const adminLogin = async (email, password, remember = false) => (await http.post("/auth/login", { email, password, remember })).data;
export const adminLogout = async () => (await http.post("/auth/logout")).data;
export const adminMe = async () => (await http.get("/admin/me")).data;
export const adminOverview = async () => (await http.get("/admin/overview")).data;
export const adminUsers = async (params = {}) => (await http.get("/admin/users", { params })).data;
export const adminUserDetail = async (id) => (await http.get(`/admin/users/${id}`)).data;
export const adminCreateMember = async (payload) => (await http.post("/admin/users", payload)).data;
export const adminUpdateMember = async (id, payload) => (await http.patch(`/admin/users/${id}`, payload)).data;
export const adminLeads = async () => (await http.get("/admin/leads")).data;
export const adminActivity = async (params = {}) => (await http.get("/admin/activity", { params })).data;
export const mktLinks = async (params = {}) => (await http.get("/admin/marketing/links", { params })).data;
export const mktCreateLink = async (payload) => (await http.post("/admin/marketing/links", payload)).data;
export const mktPatchLink = async (id, payload) => (await http.patch(`/admin/marketing/links/${id}`, payload)).data;
export const mktReport = async (days) => (await http.get("/admin/marketing/report", { params: { days } })).data;
export const mktAttribution = async (params = {}) => (await http.get("/admin/marketing/attribution", { params })).data;

export const apiError = (e, fallback = "Algo deu errado") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || fallback;
};
